import React from 'react';
import { useSelector } from 'react-redux';
import RightPanel from './rightPanel';
import CenterPanel from './centerPanel';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';

const ContentForgotPassword = () => {
  const resetingPassword = useSelector((state) => state.usersReducer.resetingPassword);
  const userEmailForPasswordReset = useSelector((state) => state.usersReducer.userEmailForPasswordReset);
  const showForgetPasswordModal = useSelector((state) => state.modalReducer.showForgetPasswordModal);
  const passwordResetRequestCompleted = useSelector((state) => state.usersReducer.passwordResetRequestCompleted);
  const browser = useSelector((state) => state.browser);

  const openForgotPasswordHelp = () => {
    window.open(APP.EXTERNAL_LINKS.Login.ForgotPassword, '_blank');
  };
  let showModal = showForgetPasswordModal;
  return (
    <Modal show={showModal} hideWhenClickAway={false} className="ui modal forgot-password">
      <PopupHeader
        hideHelp={true}
        title={
          !passwordResetRequestCompleted
            ? APP.LANGUAGE.ForgotPassword.Title
            : APP.LANGUAGE.ForgotPassword.TitleResetEmailSent
        }
      />

      <div className="content">
        <div className="main-ui-container user-forgot-password">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">
                <RightPanel
                  resetingPassword={resetingPassword}
                  userEmail={userEmailForPasswordReset}
                  passwordResetRequestCompleted={passwordResetRequestCompleted}
                />
              </div>
            </div>
            <CenterPanel
              browser={browser}
              userEmail={userEmailForPasswordReset}
              passwordResetRequestCompleted={passwordResetRequestCompleted}
            />
            <div className="bottom-rail-with-left-and-right-content mrtnull">
              <RightPanel
                resetingPassword={resetingPassword}
                userEmail={userEmailForPasswordReset}
                passwordResetRequestCompleted={passwordResetRequestCompleted}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ContentForgotPassword;
